import { ErrorBaseView } from 'General/Views/Static/Error/ErrorBaseView';

export class ErrorView extends ErrorBaseView { }